import { createComponent } from './utils/create-component';
import propTypes from './utils/prop-types';
import { ERROR_EVENT, LOAD_EVENT, CLICK_EVENT } from './utils/constants';
import { addPxUnit } from './utils/format';
import { ref, openBlock, createElementBlock, normalizeStyle, normalizeClass, createElementVNode, reactive, resolveComponent, createBlock } from 'vue';

var props = {
  /**
   * 图片地址
   */
  src: propTypes.string().def(''),
  /**
   * 头像大小
   */
  size: propTypes.oneOfType([propTypes.string(), propTypes.number()]).def(''),
  /**
   * 头像默认样式
   */
  mode: propTypes.string().def('single'),
  /**
   * 头像适应容器框方式
   */
  fit: propTypes.string().def('cover')
};
var emits = [ERROR_EVENT, LOAD_EVENT, CLICK_EVENT];

var script$1 = {
  props: ['mode', 'className', 'imageStyle'],
  setup: function setup(props) {
    var isSingleMode = ref(props.mode === 'single' ? true : false);
    return {
      isSingleMode: isSingleMode
    };
  }
};

var _hoisted_1$1 = /*#__PURE__*/createElementVNode("mask", {
  id: "mask0_819_6628",
  style: {
    "mask-type": "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: "2",
  y: "2",
  width: "83",
  height: "83"
}, [/*#__PURE__*/createElementVNode("circle", {
  cx: "43.9336",
  cy: "43.9331",
  r: "41",
  fill: "white"
})], -1 /* HOISTED */);
var _hoisted_2 = {
  mask: "url(#mask0_819_6628)"
};
var _hoisted_3 = /*#__PURE__*/createElementVNode("mask", {
  id: "mask0_2750_13372",
  style: {
    "mask-type": "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: "1",
  y: "1",
  width: "46",
  height: "46"
}, [/*#__PURE__*/createElementVNode("circle", {
  cx: "24",
  cy: "24",
  r: "22.5",
  fill: "white"
})], -1 /* HOISTED */);
var _hoisted_4 = {
  mask: "url(#mask0_2750_13372)"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [$setup.isSingleMode ? (openBlock(), createElementBlock("svg", {
    key: 0,
    style: normalizeStyle($props.imageStyle),
    viewBox: "0 0 88 88",
    "class": normalizeClass("".concat($props.className, "__customize")),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [createElementVNode("circle", {
    cx: "44",
    cy: "44",
    r: "44",
    "class": normalizeClass("".concat($props.className, "__svg_single-bg"))
  }, null, 2 /* CLASS */), _hoisted_1$1, createElementVNode("g", _hoisted_2, [createElementVNode("ellipse", {
    cx: "44.0005",
    cy: "73.8574",
    rx: "30.9048",
    ry: "16.2383",
    "class": normalizeClass("".concat($props.className, "__svg_single-body"))
  }, null, 2 /* CLASS */), createElementVNode("ellipse", {
    cx: "44.0007",
    cy: "35.3572",
    rx: "14.6667",
    ry: "15.4524",
    "class": normalizeClass("".concat($props.className, "__svg_single-body"))
  }, null, 2 /* CLASS */)])], 6 /* CLASS, STYLE */)) : (openBlock(), createElementBlock("svg", {
    key: 1,
    style: normalizeStyle($props.imageStyle),
    "class": normalizeClass("".concat($props.className, "__customize")),
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [createElementVNode("circle", {
    cx: "24",
    cy: "24",
    r: "24",
    "class": normalizeClass("".concat($props.className, "__svg_double-bg"))
  }, null, 2 /* CLASS */), createElementVNode("circle", {
    cx: "24",
    cy: "24",
    r: "22.5",
    "class": normalizeClass("".concat($props.className, "__svg_double-bg"))
  }, null, 2 /* CLASS */), _hoisted_3, createElementVNode("g", _hoisted_4, [createElementVNode("ellipse", {
    cx: "33.3992",
    cy: "37.2822",
    rx: "11.8992",
    ry: "6.35907",
    "class": normalizeClass("".concat($props.className, "__svg_double-body-left"))
  }, null, 2 /* CLASS */), createElementVNode("ellipse", {
    cx: "31.3992",
    cy: "20.2052",
    rx: "5.64706",
    ry: "6.05128",
    "class": normalizeClass("".concat($props.className, "__svg_double-body-left"))
  }, null, 2 /* CLASS */), createElementVNode("path", {
    d: "M19.8571 50.1922C24.6931 50.1922 29.141 49.1653 32.431 47.4366C35.6556 45.7423 38.1205 43.1576 38.1205 39.9287C38.1205 36.6997 35.6556 34.1151 32.431 32.4208C29.141 30.6921 24.6931 29.6652 19.8571 29.6652C15.0212 29.6652 10.5733 30.6921 7.28325 32.4208C4.05869 34.1151 1.59375 36.6997 1.59375 39.9287C1.59375 43.1576 4.05869 45.7423 7.28325 47.4366C10.5733 49.1653 15.0212 50.1922 19.8571 50.1922Z",
    "class": normalizeClass("".concat($props.className, "__svg_double-body-right")),
    "stroke-width": "2.8125"
  }, null, 2 /* CLASS */), createElementVNode("path", {
    d: "M19.8571 28.7634C25.1203 28.7634 29.2634 24.2901 29.2634 18.9286C29.2634 13.567 25.1203 9.09375 19.8571 9.09375C14.594 9.09375 10.4509 13.567 10.4509 18.9286C10.4509 24.2901 14.594 28.7634 19.8571 28.7634Z",
    "class": normalizeClass("".concat($props.className, "__svg_double-body-right")),
    "stroke-width": "2.8125"
  }, null, 2 /* CLASS */)])], 6 /* CLASS, STYLE */))]);
}

script$1.render = render$1;
script$1.__file = "components/src/component/avatar/default-avatar.vue";

var _createComponent = createComponent('avatar'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  props: props,
  emits: emits,
  components: {
    AvatarDefault: script$1
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var isUserAvatar = ref(props.src === '' ? false : true); // isUserAvatar为 true 时用户上传了有效图片资源
    // 用户自定义头像样式
    var imageStyle = reactive({
      width: addPxUnit(props.size),
      height: addPxUnit(props.size),
      'object-fit': props.fit
    });
    //图片加载失败使用兜底头像样式
    function handleError(e) {
      isUserAvatar.value = false;
      emit(ERROR_EVENT, e);
    }
    function handleLoad(e) {
      emit(LOAD_EVENT, e);
    }
    function handleClick(e) {
      emit(CLICK_EVENT, e);
    }
    return {
      className: className,
      imageStyle: imageStyle,
      isUserAvatar: isUserAvatar,
      handleError: handleError,
      handleLoad: handleLoad,
      handleClick: handleClick
    };
  }
});

var _hoisted_1 = ["src"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_AvatarDefault = resolveComponent("AvatarDefault");
  return openBlock(), createElementBlock("div", {
    "class": normalizeClass(_ctx.className),
    onClick: _cache[2] || (_cache[2] = function () {
      return _ctx.handleClick && _ctx.handleClick.apply(_ctx, arguments);
    })
  }, [_ctx.isUserAvatar ? (openBlock(), createElementBlock("img", {
    key: 0,
    src: _ctx.src,
    style: normalizeStyle(_ctx.imageStyle),
    "class": normalizeClass("".concat(_ctx.className, "__customize")),
    onError: _cache[0] || (_cache[0] = function () {
      return _ctx.handleError && _ctx.handleError.apply(_ctx, arguments);
    }),
    onLoad: _cache[1] || (_cache[1] = function () {
      return _ctx.handleLoad && _ctx.handleLoad.apply(_ctx, arguments);
    })
  }, null, 46 /* CLASS, STYLE, PROPS, HYDRATE_EVENTS */, _hoisted_1)) : (openBlock(), createBlock(_component_AvatarDefault, {
    key: 1,
    className: _ctx.className,
    imageStyle: _ctx.imageStyle,
    mode: _ctx.mode
  }, null, 8 /* PROPS */, ["className", "imageStyle", "mode"]))], 2 /* CLASS */);
}

script.render = render;
script.__file = "components/src/component/avatar/avatar.vue";

var _Avatar = script;

export { _Avatar as default };
